import sanitizeHtml from 'sanitize-html';

const RAG_HIGHLIGHT_TAGS = ['mark', 'em', 'strong'];

export const sanitizeRagHighlightedHtml = (value = '') => sanitizeHtml(String(value || ''), {
    allowedTags: RAG_HIGHLIGHT_TAGS,
    allowedAttributes: {},
    allowedSchemes: [],
    disallowedTagsMode: 'discard',
    enforceHtmlBoundary: true,
});

